<template>
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M19.7339 3.3908L3.42138 12.7775C2.78857 13.1291 2.85888 14.0431 3.4917 14.2892L7.25342 15.8713L17.3433 6.97674C17.519 6.80096 17.8003 7.04705 17.6245 7.25799L9.18701 17.5588V20.4064C9.18701 21.2502 10.1714 21.5666 10.6636 20.9689L12.9136 18.2267L17.2729 20.09C17.7651 20.301 18.3628 19.9845 18.4331 19.422L20.9644 4.23455C21.105 3.53142 20.3315 3.03924 19.7339 3.3908Z"
        />
    </svg>
</template>
